import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Page } from "../components/Page";
import { RioApiGet, RioApiPost, RioResources, IRioResource, RioIf, RioConfirmModal, RioIconButton, IRioModelErrors, RioLoadingIf, RioForEach } from "rio.react.all";
import { DataVineGridView } from "../components/GridView/GridView";
import { IGridViewColumn } from "../components/GridView/IGridViewColumn";
import { IGridViewAction } from "../components/GridView/IGridViewAction";
import { LandingWineCampaignApiModel } from "../apiModels/LandingWineCampaignApiModel";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import { LandingWineManualSendTestModal } from "../modals/LandingWineManualSendTestModal";
import { LandingWinesManualSendApiModel } from "../apiModels/LandingWinesManualSendViewModel";

interface ILandingWinesManualSendProps extends RouteComponentProps {
	
}

interface ILandingWinesManualSendState {
	campaigns: Array<LandingWineCampaignApiModel>;
	selectedCount: number;
	selectAllResource: IRioResource,
	completeClickedItem: LandingWineCampaignApiModel,
	manuallyQueueCampaignsClicked: boolean,
	testRunClicked: boolean,
	sendClicked: boolean,
	errorMessages: Array<string>;
	loading: boolean;
	processing: boolean;
	selectedCampaigns: Array<LandingWineCampaignApiModel>;
}

export class LandingWinesManualSend extends React.Component<ILandingWinesManualSendProps, ILandingWinesManualSendState> {
	constructor(props: Readonly<ILandingWinesManualSendProps>) {
        super(props);

		this.state = {
			campaigns: [],
			selectedCount: 0,
			selectAllResource: RioResources.find("SelectAll"),
			completeClickedItem: null,
			manuallyQueueCampaignsClicked: false,
			testRunClicked: false,
			sendClicked: false,
			errorMessages: [],
			loading: true,
			processing: false,
			selectedCampaigns: []
		};
	}

	private landingWineTemplateID: number

	private gridviewRef = React.createRef<DataVineGridView<LandingWineCampaignApiModel>>();
	private selectAll = RioResources.find("SelectAll");
	private deselectAll = RioResources.find("DeSelectAll");

	columns: Array<IGridViewColumn<LandingWineCampaignApiModel>> = [
		{ title: RioResources.find("CustomerNo").text, displayValue: (item) => item.customerNo, value: (item) => item.customerNo },
		{ title: RioResources.find("CustomerName").text, displayValue: (item) => item.customer.name, value: (item) => item.customer.name },
		{ title: RioResources.find("Email").text, displayValue: (item) => item.customer.email, value: (item) => item.customer.email },
		{ title: RioResources.find("Subject").text, displayValue: (item) => item.nextTemplateSubject, value: (item) => item.nextTemplateSubject },
		{ title: RioResources.find("LastEmailSent").text, displayValue: (item) => item.lastEmailSent, value: (item) => item.lastEmailSent },
	];

	actions: Array<IGridViewAction<LandingWineCampaignApiModel>> = [
		{ resource: RioResources.find("Complete"), onClick: (item) => this.handleCompleteClicked(item), hasPermission: true, visible: (item) => !item.formCompleted },
	];

	render() {
		return (
			<Page heading={RioResources.find("LandingWinesManualSend")}>
				<RioLoadingIf condition={!!this.state.loading || this.state.processing}>
					<RioIf condition={this.state.errorMessages != null && this.state.errorMessages.length > 0} then={
						<div className="validationSummary">
							<RioForEach items={this.state.errorMessages} perform={(error, index) => {
								return <div key={`${index}`} className="fieldValidationError">{error}</div>;
							}} />
						</div>

					} />
					<div className="accountStatementButtonsWrapper">
						<div className="left">
							<RioIf condition={this.state.campaigns.length > 0} then={
								<React.Fragment>
									<RioIconButton resource={this.state.selectAllResource} onClick={() => this.selectAndDeselectAll()} hideImage={true} hasPermission={true} />
									<RioIconButton resource={RioResources.find("SelectVisible")} onClick={() => this.selectVisible()} hideImage={true} hasPermission={true} />
								</React.Fragment>
							} />
						</div>
						<div className="right">
							<RioIconButton resource={RioResources.find("RefreshList")} onClick={() => this.handleManuallyQueueCampaignsClicked()} hasPermission={true} />
							<RioIconButton resource={RioResources.find("TestRun")} onClick={() => this.handleTestRunClicked()} hasPermission={true} />
							<RioIconButton resource={RioResources.find("Send")} onClick={() => this.handleSendClicked()} hasPermission={true} />
						</div>
					</div>

					<DataVineGridView<LandingWineCampaignApiModel>
						ref={this.gridviewRef}
						noResults={RioResources.find("NoResultsFound")}
						columns={this.columns}
						actions={this.actions}
						items={this.state.campaigns}
						pageSize={50}
						rowKey={(item: LandingWineCampaignApiModel) => item.landingWineCampaignID}
						rowIsSelectable={() => true}
						selectableRowTitle={RioResources.find("Selected").text}
						onSelectedChanged={(items) => this.selectedChanged(items)}
					/>


					<RioIf condition={!!this.state.completeClickedItem} then={
						<RioConfirmModal text={RioResources.find("CompleteClickedConfirmMsg")} onConfirmModalClosed={(result) => this.confirmCompleteClicked(result)} className="confirmModal" />
					} />

					<RioIf condition={!!this.state.manuallyQueueCampaignsClicked} then={
						<RioConfirmModal text={RioResources.find("ManuallyQueueCampaignsClickedConfirmMsg")} onConfirmModalClosed={(result) => this.confirmManuallyQueueCampaigns(result)} className="confirmModal" />
					} />

					<RioIf condition={!!this.state.testRunClicked} then={
						<LandingWineManualSendTestModal selectedCampaigns={this.state.selectedCampaigns} onClose={() => this.handleManualSendModalClosed()} />
					} />

					<RioIf condition={!!this.state.sendClicked} then={
						<RioConfirmModal text={RioResources.find("LandingWineSendConfirmMessage")} onConfirmModalClosed={(result) => this.confirmSendClicked(result)} className="confirmModal" />
					} />
				</RioLoadingIf>
			</Page>
		);
	}

	componentDidMount(): void {
        this.loadData();
    }

	loadData(): void {	
		// Todo: There must be a better way to get the query string value
		let idString = this.props.location.search
			.replace('?', '')
			.split('&')
			.filter((i) => i.startsWith('id='));
		let idKeyValue = !!idString && idString.length > 0
			? idString[0].split('=')
			: [];
		let landingWineTemplateID = !!idKeyValue && idKeyValue.length == 2
			? idKeyValue[1]
			: 0;

		RioApiGet.asPromise<Array<LandingWineCampaignApiModel>>("/api/LandingWineCampaign/GetForEmailSendJob/" + landingWineTemplateID)
			.then(response => {
				this.setState({
					campaigns: response,
					loading: false,
					processing: false
				});
			});
	}

	handleManuallyQueueCampaignsClicked() {
		this.setState({ 
			manuallyQueueCampaignsClicked: true
		})
	}

	confirmManuallyQueueCampaigns(result: boolean) {
		if (result) {
			this.setState({
				processing: true
			});
			RioApiPost.asPromise("/api/LandingWineCampaign/ManuallyQueueCampaigns/", {})
				.then((response) => {
					this.loadData();
				})
				.catch((response) => {
					if (response?.errors != null) {
						this.appendErrorMessages(response.errors);
					} else {
						let error: IRioModelErrors = {
							ValidationSummary: [RioResources.find("UnexpectedErrorMsg").text]
						}

						this.appendErrorMessages(error);
					}

					this.setState({
						processing: false
					});
				});
		}

		this.setState({
			manuallyQueueCampaignsClicked: false
		})
	}

	handleTestRunClicked() {
		if (this.state.selectedCampaigns.length > 0) {
			this.setState({
				testRunClicked: true
			})
		}
	}

	handleSendClicked() {
		this.setState({
			sendClicked: true
		})
	}

	confirmSendClicked(result: boolean) {
		if (result) {
			if (this.state.selectedCampaigns.length > 0) {
				this.setState({
					processing: true
				});

				let vm = new LandingWinesManualSendApiModel;
				vm.testRun = false;
				vm.campaigns = this.state.selectedCampaigns;

				RioApiPost.asPromise("/api/LandingWineCampaign/Send/", vm)
					.then((response) => {
						this.loadData();
					})
					.catch((response) => {
						if (response?.errors != null) {
							this.appendErrorMessages(response.errors);
						} else {
							let error: IRioModelErrors = {
								ValidationSummary: [RioResources.find("UnexpectedErrorMsg").text]
							}

							this.appendErrorMessages(error);
						}
						
						this.loadData();
					});
			}
		}

		this.setState({
			sendClicked: false
		})
	}

	handleCompleteClicked(item: LandingWineCampaignApiModel) {
		this.setState({
			completeClickedItem: item,
		});
	}

	confirmCompleteClicked(result: boolean) {
		if (result) {
			RioApiPost.asPromise("/api/LandingWineCampaign/SetAsComplete/", this.state.completeClickedItem.landingWineCampaignID)
				.then((response) => {
					this.loadData();
				})
				.catch((response) => {
					if (response?.errors != null) {
						this.appendErrorMessages(response.errors);
					} else {
						let error: IRioModelErrors = {
							ValidationSummary: [RioResources.find("UnexpectedErrorMsg").text]
						}

						this.appendErrorMessages(error);
					}

					this.setState({
						processing: false
					});
				});

		}

		this.setState({
			completeClickedItem: null,
		});
	}

	selectAndDeselectAll() {
		if (this.state.selectedCount !== this.state.campaigns.length) {
			this.gridviewRef.current.selectAll();
		} else {
			this.gridviewRef.current.deselectAll();
		}
	}

	selectVisible() {
		this.gridviewRef.current.selectVisibleItems();
	}

	selectedChanged(items: Array<LandingWineCampaignApiModel>) {
		if (!!this.state.campaigns) {
			let count = items != null && !!items.length ? items.length : 0 //nullable operators don't work with whatever is building the typescript
			let text = count !== this.state.campaigns.length
				? this.selectAll
				: this.deselectAll;

			this.setState({
				selectedCount: count,
				selectAllResource: text,
				selectedCampaigns: this.gridviewRef.current.getSelectedItems()
			});
		}
	}

	appendErrorMessages(errors: IRioModelErrors) {
		let errorMessages: Array<string> = []; //ValidationSummary is currently broken, so use this as a quick workaround
		for (var key in errors["ValidationSummary"]) {
			errorMessages.push(errors["ValidationSummary"][key]);
		}

		this.setState({
			errorMessages: errorMessages
		});
	}

	handleManualSendModalClosed() {
		this.loadData();
		this.setState({
			testRunClicked: false
		});
	}
}
